import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MAGNIFIER_INITIAL_STATE } from './magnifier.constants';
import { MagnifierState } from './magnifier.types';

const magnifierSlice = createSlice({
  name: 'magnifier',
  initialState: MAGNIFIER_INITIAL_STATE,
  reducers: {
    toggleMagnifier: state => {
      state.isActive = !state.isActive;
    },
    setMagnifierActive: (state: MagnifierState, action: PayloadAction<boolean>) => {
      state.isActive = action.payload;
    },
  },
});

export const { toggleMagnifier, setMagnifierActive } = magnifierSlice.actions;

export default magnifierSlice.reducer;
